module.exports = __webpack_public_path__ + "static/img/Brendan.Lee.ced105b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Brendan.Lee.jpg
// module id = sI9/
// module chunks = 0